// Container for __ARTIST__ CASE STUDY collection slides 
// Connect to redux, fetch appropriate slides 

import { connect } from 'react-redux'
import {
  fetchArtistCaseStudy
} from './actions'
import {
  getPageArtistSt
} from '../app/selectors'
import {
  getArtistCaseStudyRows,
  getArtistCaseStudyFetching,
  getArtistCaseStudyRequestId,
  getArtistCaseStudyColours,
  getArtistTitle
} from './selectors'
import ArtistCaseStudies from './artist-case-studies'

const mapStateToProps = state => {
  return {
    requestId: getArtistCaseStudyRequestId(state),
    rows: getArtistCaseStudyRows(state),
    fetching: getArtistCaseStudyFetching(state),
    colours: getArtistCaseStudyColours(state),
    title: getArtistTitle(state),
    pageArtistSt: getPageArtistSt(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onRequestRows: id => {
      dispatch(fetchArtistCaseStudy(id))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArtistCaseStudies)



// WEBPACK FOOTER //
// ./src/components/artist-case-studies-container/index.js